<template>
  <v-app-bar
    elevate-on-scroll
    app
  >
    <v-app-bar-nav-icon @click="toggleNav" />
    <v-spacer />
    <v-btn
      class="mr-4"
      @click="showSync"
    >
      Sync
    </v-btn>
    <HeaderSearch />
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex';
import HeaderSearch from '../common/HeaderSearch';

export default {
  name: 'AppBar',
  components: { HeaderSearch },
  data: () => ({}),
  computed: {
    ...mapGetters({})
  },
  methods: {
    toggleNav() {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.SET_NAV_VISIBILITY, 'toggle');
    },
    showSync() {
      this.$bus.$emit(this.$enums.EVENT_BUS_EVENTS.CACHE_SYNC_SHOW, {});
    }
  }
};
</script>
